import { Injectable } from '@angular/core';
import { LoaderSpinner } from '@models/loader-spiner.interface';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class LoaderSpinerService {

    private loaderSubject = new BehaviorSubject<LoaderSpinner>({ isActive: false });
    loaderSpiner$ = this.loaderSubject.asObservable();


    startLoader(message?: string) {
        this.loaderSubject.next({ isActive: true, message: message });
    }

    finishLoader() {
        this.loaderSubject.next({ isActive: false });
    }

}